/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../apiClient'
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from '../../apiClient'
import type {
  CreateHomepagePinMutationRequest,
  CreateHomepagePinMutationResponse,
  CreateHomepagePin400,
} from '../types/CreateHomepagePin'

function getCreateHomepagePinUrl() {
  const res = { method: 'POST', url: `/api/v1/homepage/pins/` as const }
  return res
}

/**
 * @summary Pin a record or page to the homepage
 * {@link /api/v1/homepage/pins/}
 */
export async function createHomepagePin(
  data: CreateHomepagePinMutationRequest,
  config: Partial<RequestConfig<CreateHomepagePinMutationRequest>> & {
    client?: Client
  } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<
    CreateHomepagePinMutationResponse,
    ResponseErrorConfig<CreateHomepagePin400>,
    CreateHomepagePinMutationRequest
  >({
    method: 'POST',
    url: getCreateHomepagePinUrl().url.toString(),
    data: requestData,
    ...requestConfig,
  })
  return res.data
}
